import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  AccountLockedList,
  addEmployeeProfile,
  addPositions,
  CanLoginApp,
  ChangeEmployeeStatus,
  DayLockedDatesByID,
  DayLockedList,
  DocumnetAccountLockedList,
  EditProfile,
  getAllPositionList,
  GetAttendanceList,
  getBranches,
  getDailyCallByAttendance,
  getDesignations,
  getEmployeeDetailsByID,
  getEmployeeGeoTown,
  GetEmployeeLeaveBAlance,
  getEmployeeList,
  getEmployeeStatus,
  getEODstatus,
  getExpenseSingleDateById,
  getGradeMasters,
  getLeaveListByEmployee,
  getOrgUnits,
  getPositionById,
  getPositionData,
  getPositionListNew,
  getReportingToPositionData,
  getReportingToPositionsByOrgUnit,
  getRoles,
  GetSGPIListByEMP,
  getSingleAttendance,
  getTownFilter,
  getUserProfile,
  getUserSession,
  regenerateExpense,
  ReleaseAccountLocked,
  ReleaseAllDayLock,
  ReleaseDayLockedDates,
  updateAttendance,
  UpdateHrUserDates,
  updatePositions,
  UpdateUserProfile,
} from "./EmployeeRepository";
import { toast } from "react-toastify";
import { showToast } from "../../../utils/toastUtils";

export const useEmployeeListData = ({
  enable = false,
  params = {},
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["GET_EMPLOYEE_LIST", params],
    queryFn: () => getEmployeeList(params),
    enabled: enable,
    retry: false,
    //   staleTime: 5 * 60 * 1000,
  });
};

export const useGetOrgUnitsData = ({
  enable = false,
}: { enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["GET_ORG_DATA"],
    queryFn: getOrgUnits,
    enabled: enable,
    retry: false,
  });
};
export const useGetGradeMastersData = ({
  enable = false,
}: { enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["GET_GRADE_MASTER"],
    queryFn: getGradeMasters,
    enabled: enable,
    retry: false,
  });
};
export const useGetDesignationsData = ({
  enable = false,
}: { enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["GET_DESIGNATIONS"],
    queryFn: getDesignations,
    enabled: enable,
    retry: false,
  });
};
export const useGetEmployeeStatusData = ({
  enable = false,
}: { enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["GET_EMPLOYEE_STATUS"],
    queryFn: getEmployeeStatus,
    enabled: enable,
    retry: false,
  });
};
export const useGetEODstatus = ({
  enable = false,
}: { enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["GET_EOD_STATUS"],
    queryFn: getEODstatus,
    enabled: enable,
    retry: false,
  });
};

export const useGetEmployeeStatus = ({
  enable = false,
}: { enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["GET_EOD_STATUS"],
    queryFn: getEODstatus,
    enabled: enable,
    retry: false,
  });
};

export const useGetFullSyncStatus = ({
  enable = false,
}: { enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["GET_CAN_FULL_SYNC_STATUS"],
    queryFn: getEODstatus,
    enabled: enable,
    retry: false,
  });
};

export const useEmployeeDetailsById = (
  {params,
    enable
  }:{params: Record<string,any>,
  enable:boolean}
) => {
 console.log('paraaams',params)
  return useQuery({
    queryKey: ["GET_EMPLOYEE_DETAILS_BY_ID",params ],
    queryFn: () => getEmployeeDetailsByID(params),
    enabled: enable,
    retry: false,
  });
};

export const usePositionData = ({
  enable = false,
  params = {},
}: { enable?: boolean; params?: Record<string, any> } = {}) => {
  return useQuery({
    queryKey: ["GET_EMPLOYEE_POSITION", params],
    queryFn: () => getPositionData(params),
    enabled: enable,
    retry: false,
  });
};

export const useReportingToPositionData = ({
  enable = false,
  params = {},
}: { enable?: boolean; params?: Record<string, any> } = {}) => {
  return useQuery({
    queryKey: ["GET_EMPLOYEE_REPORTING_TO_POSITION",params],
    queryFn: () => getReportingToPositionData(params),
    enabled: enable,
    retry: false,
  });
};

export const useEditProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => EditProfile(data),
    onSuccess: (data) => {
      showToast.success(data.message);
      queryClient.invalidateQueries({ queryKey: ["EDIT_PROFILE"] });
      queryClient.invalidateQueries({ queryKey: ["GET_EMPLOYEE_DETAILS_BY_ID"] });
    },
    onError: (error) => {
      toast.error("Failed to update profile!");
    },
  });
};

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => UpdateUserProfile(data),
    onSuccess: (data) => {
      toast.success("User Profile updated successfully!");
      queryClient.invalidateQueries({
        queryKey: ["GET_EMPLOYEE_DETAILS_BY_ID"],
        
        
      });
       queryClient.invalidateQueries({
       
        queryKey: ["GET_USER_PROFILE"],
        
      });
    },
    onError: (error) => {
      console.log("Failed to update User profile!",error);
    },
  });
};

export const useDayLockedListData = ({
  enable = false,
  params = {},
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["GET_DAY_LOCKED_LIST", params],
    queryFn: () => DayLockedList(params),
    enabled: enable,
    retry: false,
    //   staleTime: 5 * 60 * 1000,
  });
};

export const useDayLockedListDataByID = ({
  enable = false,
  params = {},
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["GET_DAY_LOCKED_DATE_BY_ID", params],
    queryFn: () => DayLockedDatesByID(params),
    enabled: enable,
    retry: false,
    //   staleTime: 5 * 60 * 1000,
  });
};

export const useReleaseDayLocked = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reqBody: any) => ReleaseDayLockedDates(reqBody),

    onSuccess: (res) => {
      showToast.success(res.message);
      // queryClient.invalidateQueries({ queryKey: ["GET_DAY_LOCKED_LIST"] });
      // queryClient.invalidateQueries({ queryKey: ["GET_DAY_LOCKED_DATE_BY_ID"] });
    },
    onError: (error: any) => {
     showToast.warning(error.message);
    },
  });
};

export const useReleaseAllDayLocked = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reqBody: any) => ReleaseAllDayLock(reqBody),

    onSuccess: (res) => {
      showToast.success(res.message);
      queryClient.invalidateQueries({ queryKey: ["LOCKED_DAY_RELEASED"] });
      queryClient.invalidateQueries({ queryKey: ["GET_ATTENDANCE"] });
    },
    onError: (error: any) => {
      console.error("Failed to Release Account:", error.message);
    },
  });
};

export const useAccountLockedListData = ({
  enable = false,
  params = {},
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["GET_ACCOUNT_LOCKED_LIST", params],
    queryFn: () => AccountLockedList(params),
    enabled: enable,
    retry: false,
    //   staleTime: 5 * 60 * 1000,
  });
};

export const useDocumentAccountLockedListData = ({
  enable = false,
  params = {},
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["GET_DOCUMENT_ACCOUNT_LOCKED_LIST", params],
    queryFn: () => DocumnetAccountLockedList(params),
    enabled: enable,
    retry: false,
    //   staleTime: 5 * 60 * 1000,
  });
};

export const useReleaseAccountLocked = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reqBody: any) => ReleaseAccountLocked(reqBody),

    onSuccess: (res) => {
      showToast.success(res.message);
      queryClient.invalidateQueries({ queryKey: ["LOCKED_ACCOUNT_RELEASED"] });
      queryClient.invalidateQueries({ queryKey: ["GET_ACCOUNT_LOCKED_LIST"] });
      queryClient.invalidateQueries({ queryKey: ["GET_EMPLOYEE_LIST"] });
      
    },
    onError: (error: any) => {
      console.error("Failed to Release Account:", error.message);
    },
  });
};

export const useUserSession = ({
  enabled,
  empId,
  params = {},
}: {
  enabled: boolean;
  empId: number;
  params?: Record<string, any>;
}) => {
  return useQuery({
    queryKey: ["GET_USER_SESSION", empId, params],
    queryFn: () => getUserSession(empId, params),
    enabled,
    retry: false,
  });
};

export const useUserProfile = ({
  enabled,
  params = {},
}: {
  enabled: boolean;
  params?: Record<string, any>;
}) => {
  return useQuery({
    queryKey: ["GET_USER_PROFILE", params],
    queryFn: () => getUserProfile(params),
    enabled,
    retry: false,
  });
};

export const useRoles = ({
  enabled,
  params = {},
}: {
  enabled: boolean;
  params?: Record<string, any>;
}) => {
  return useQuery({
    queryKey: ["GET_Roles", params],
    queryFn: () => getRoles(params),
    enabled,
    retry: false,
  });
};

export const useCanLoginApp = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reqBody: any) => CanLoginApp(reqBody),

    onSuccess: () => {
      toast.success("Can Login App Updated");
      queryClient.invalidateQueries({ queryKey: ["CAN_LOGIN_ACCESS"] });
    },
    onError: (error: any) => {
      console.error("Failed to Update:", error.message);
    },
  });
};

export const useChangeEmployeeStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reqBody: any) => ChangeEmployeeStatus(reqBody),

    onSuccess: () => {
      toast.success("Employee Status Updated");
      queryClient.invalidateQueries({ queryKey: ["CHANGE_EMPLOYEE_STATUS"] });
    },
    onError: (error: any) => {
      console.error("Failed to Update Employee Status:", error.message);
    },
  });
};

export const useUpdateHrUserDates = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reqBody: any) => UpdateHrUserDates(reqBody),

    onSuccess: (e:any) => {
      // toast.success(e.message);
      queryClient.invalidateQueries({ queryKey: ["CHANGE_HR_USER_DATES"] });
    },
    onError: (error: any) => {
      console.error("Failed to Update Employee:", error.message);
    },
  });
};

export const useAttendanceList = ({
  enabled,
  params = {},
}: {
  enabled: boolean;
  params?: Record<string, any>;
}) => {
  return useQuery({
    queryKey: ["GET_ATTENDANCE", params],
    queryFn: () => GetAttendanceList(params),
    enabled,
    retry: false,
  });
};

export const useSGPIListById = ({
  enabled,
  empId,
  params
  
}: {
  enabled: boolean;
  empId?: Number;
    params: Record<string, any>;
}) => {
  return useQuery({
    queryKey: ["GET_SGPI_BY_ID", empId,params],
    queryFn: () => {
      if (empId === undefined) throw new Error("empId is required");
      return GetSGPIListByEMP(empId,params);
    },
    enabled: enabled && empId !== undefined,
    retry: false,
  });
};

export const useLeaveBalanceByEmployee = ({
  enabled,
  params = {},
}: {
  enabled: boolean;
  params?: Record<string, any>;
}) => {
  return useQuery({
    queryKey: ["GET_LEAVE_BALANCE_BY_EMPLOYEE", params],
    queryFn: () => GetEmployeeLeaveBAlance(params),
    enabled,
    retry: false,
  });
};

export const useLeaveListByEmployee = ({
  enabled,
  params = {},
}: {
  enabled: boolean;
  params?: Record<string, any>;
}) => {
  return useQuery({
    queryKey: ["GET_LEAVES_BY_EMPLOYEE", params],
    queryFn: () => getLeaveListByEmployee(params),
    enabled,
    retry: false,
  });
};

export const useDailyCallByAttendance = ({
  enabled,
  params = {},
}: {
  enabled: boolean;
  params?: Record<string, any>;
}) => {
  return useQuery({
    queryKey: ["GET_DAILY_CALLS_BY_ATTENDANCE", params],
    queryFn: () => getDailyCallByAttendance(params),
    enabled,
    retry: false,
  });
};

export const useAllPositionList = ({
  enabled,
  params = {},
}: {
  enabled: boolean;
  params?: Record<string, any>;
}) => {
  return useQuery({
    queryKey: ["GET_ALL_POSITION_LIST", params],
    queryFn: () => getAllPositionList(params),
    enabled,
    retry: false,
  });
};

export const useGetExpenseSingleDateById = ({
  enabled,
  params = {},
  id,
}: {
  enabled: boolean;
  params?: Record<string, any>;
  id: number;
}) => {
  return useQuery({
    queryKey: ["GET_EXPENSE_SINGLE_DATE_BY_EMPLOYEE_ID", params, id],
    queryFn: () => getExpenseSingleDateById(params, id),
    enabled,
    retry: false,
  });
};

export const useEmployeeGeoTown = ({
  enabled,
  params = {},
}: {
  enabled: boolean;
  params?: Record<string, any>;
}) => {
  return useQuery({
    queryKey: ["GET_EMPLOYEE_GEO_TOWN", params],
    queryFn: () => getEmployeeGeoTown(params),
    enabled,
    retry: false,
  });
};

export const useSingleAttendance = ({
  enabled,
  id,
}: {
  enabled: boolean;
  id: number;
}) => {
  return useQuery({
    queryKey: ["GET_SINGLE_ATTENDANCE", id],
    queryFn: () => getSingleAttendance(id),
    enabled,
    retry: false,
  });
};

export const useBranches = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: ["GET_BRANCHES"],
    queryFn: () => getBranches(),
    enabled,
    retry: false,
  });
};

export const useUpdateAttendance = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: any) => updateAttendance(body),
    onSuccess: (response) => {
      showToast.success(response.message);
      queryClient.invalidateQueries({ queryKey: ["GET_ATTENDANCE"] });
      queryClient.invalidateQueries({ queryKey: ["GET_SINGLE_ATTENDANCE"] });
    },
    onError: (error) => {
      // toast.error("Failed to update User profile!");
    },
  });
};

export const useRegenerateExpense = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: any) => regenerateExpense(body),
    onSuccess: (response) => {
       showToast.success(response.message);
      queryClient.invalidateQueries({ queryKey: ["REGENERATE_EXPENSE"] });
    },
    onError: (error) => {
      toast.error("Failed to Regenerate Expense");
    },
  });
};

export const useAddProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reqBody: any) => addEmployeeProfile(reqBody),

    onSuccess: (response) => {
      showToast.success(response.message);
      queryClient.invalidateQueries({ queryKey: ["GET_EMPLOYEE_LIST"] });
    },
    onError: (error: any) => {
      console.error("Failed to Add Employee:", error.message);
    },
  });
};


export const useGetPositionListNew = ({
  enabled,
  params = {},

}: {
  enabled: boolean;
  params?: Record<string, any>;
}) => {
  return useQuery({
    queryKey: ["GET_POSTION_LIST_NEW",params],
    queryFn: () => getPositionListNew(params),
    enabled,
    retry: false,
  });
};

export const useGetReportingToPositionsByOrgunit = ({
  enabled,
  params = {},
  id

}: {
  enabled: boolean;
  params?: Record<string, any>;
  id:any
}) => {
  return useQuery({
    queryKey: ["GET_REPORTING_TO_BY_ORG_UNIT",params,id],
    queryFn: () => getReportingToPositionsByOrgUnit(params,id),
    enabled,
    retry: false,
  });
};

export const useGetPositionById = ({
  enabled,
  id

}: {
  enabled: boolean;

  id:any
}) => {
  return useQuery({
    queryKey: ["GET_POSITION_BY_ID",id],
    queryFn: () => getPositionById(id),
    enabled,
    retry: false,
  });
};


export const useAddPosition = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reqBody: any) => addPositions(reqBody),

    onSuccess: (response) => {
       showToast.success(response.message);
      queryClient.invalidateQueries({ queryKey: ["GET_POSTION_LIST_NEW"] });
    },
    onError: (error: any) => {
      console.error("Failed to Add Position:", error.message);
    },
  });
};

export const useUpdatePosition = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({reqBody,id}:{reqBody:Record<string,any>;id:number}) => updatePositions(reqBody,id),

    onSuccess: (response) => {
      showToast.success(response.message);
      queryClient.invalidateQueries({ queryKey: ["GET_POSTION_LIST_NEW"] });
      queryClient.invalidateQueries({ queryKey: ["GET_POSITION_BY_ID"] });
    },
    onError: (error: any) => {
      console.error("Failed to Update Position:", error.message);
    },
  });
};